module.exports = require("./pt-CH.d.ts");